import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder'
);

export const signIn = (email, password) =>
  supabase.auth.signInWithPassword({ email, password });

export const signUp = (email, password) =>
  supabase.auth.signUp({ email, password });

export const signOut = () => supabase.auth.signOut();

export const uploadFile = async (file, folder = 'general') => {
  const ext = file.name.split('.').pop();
  const fileName = `${folder}/${Date.now()}_${Math.random().toString(36).slice(2)}.${ext}`;
  const { data, error } = await supabase.storage
    .from('vehicle-files')
    .upload(fileName, file, { upsert: false });
  if (error) throw error;
  const { data: urlData } = supabase.storage
    .from('vehicle-files')
    .getPublicUrl(data.path);
  return { path: data.path, url: urlData.publicUrl };
};

export const deleteFile = async (path) => {
  const { error } = await supabase.storage.from('vehicle-files').remove([path]);
  if (error) throw error;
};
